import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse, Row } from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"
import { app_url } from "app_config"
import { usePermissionData } from "AppContext"
import secureLocalStorage from "react-secure-storage"
const Navbar = props => {
  const [ui, setui] = useState(false)

  const [extra, setextra] = useState(false)

  const { checkAccess } = usePermissionData()

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  const loggedin_user = secureLocalStorage.getItem("authUser")

  const isMasterPermitted = () => {
    return (
      checkAccess(4, "view") ||
      checkAccess(5, "view") ||
      checkAccess(6, "view") ||
      checkAccess(8, "view") ||
      checkAccess(9, "view") ||
      checkAccess(10, "view") ||
      checkAccess(12, "view") ||
      checkAccess(14, "view") ||
      checkAccess(15, "view") ||
      checkAccess(16, "view") ||
      checkAccess(17, "view") ||
      checkAccess(18, "view") ||
      checkAccess(19, "view") ||
      checkAccess(20, "view") ||
      checkAccess(21, "view")
    )
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {/* dashboard */}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to={`${app_url}dashboard`}
                  >
                    <i className="fas fa-home me-2"></i>
                    {props.t("Dashboard")} {props.menuOpen}
                  </Link>
                </li>

                {isMasterPermitted() && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}`}
                      onClick={e => {
                        e.preventDefault()
                        setextra(!extra)
                      }}
                    >
                      <i className="far fa-list-alt me-2"></i>
                      {props.t("Masters")} <div className="arrow-down"></div>
                    </Link>
                    <div className={classname("dropdown-menu", { show: ui })}>
                      <div className="dropdown">
                        {checkAccess(4, "view") && (
                          <Link
                            to={`${app_url}employees`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Employee Master")}
                          </Link>
                        )}
                        {/* <div
                        className={classname("dropdown-menu", {
                          show: invoice,
                        })}
                      >
                        <Link to="#" className="dropdown-item">
                          {props.t("Invoice List")}
                        </Link>
                        <Link to="#" className="dropdown-item">
                          {props.t("Invoice Detail")}
                        </Link>
                      </div> */}
                      </div>
                      {checkAccess(5, "view") && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/practice-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Practice Master")}
                          </Link>
                        </div>
                      )}

                      {checkAccess(6, "view") && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/service-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Service Master")}
                          </Link>
                        </div>
                      )}

                      {checkAccess(31, "view") && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/service-tag-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Service Tag Master")}
                          </Link>
                        </div>
                      )}

                      {checkAccess(6, "view") && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/budget-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Budget Master")}
                          </Link>
                        </div>
                      )}

                      {/* {
                      checkAccess(7, 'view') &&
                      <div className="dropdown">
                        <Link
                          to={`${app_url}master/address-type-master`}
                          className="dropdown-item dropdown-toggle arrow-none"
                        >
                          {props.t("Address Type Master")}
                        </Link>
                      </div>
                    } */}
                      {(checkAccess(8, "view") ||
                        checkAccess(9, "view") ||
                        checkAccess(10, "view")) && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/workflow-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Workflow Master")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", { show: ui })}
                          >
                            {checkAccess(8, "view") && (
                              <Link
                                to={`${app_url}master/workflow-master/client-status`}
                                className="dropdown-item"
                              >
                                {props.t("Client Status")}
                              </Link>
                            )}
                            {checkAccess(9, "view") && (
                              <Link
                                to={`${app_url}master/workflow-master/status-master`}
                                className="dropdown-item"
                              >
                                {props.t("Status Master")}
                              </Link>
                            )}
                            {checkAccess(10, "view") && (
                              <Link
                                to={`${app_url}master/workflow-master/work-type`}
                                className="dropdown-item"
                              >
                                {props.t("Work Type")}
                              </Link>
                            )}
                          </div>
                        </div>
                      )}

                      {
                        // (checkAccess(11, 'view') ||
                        checkAccess(12, "view") && (
                          // || checkAccess(13, 'view'))
                          <div className="dropdown">
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${app_url}master/deadline-master`}
                            >
                              {props.t("Deadline Master")}{" "}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              className={classname("dropdown-menu", {
                                show: ui,
                              })}
                            >
                              {/* {
                            checkAccess(11, 'view') &&
                            <Link to={`${app_url}master/deadline-master/VAT-period`} className="dropdown-item">
                              {props.t("VAT Period")}
                            </Link>
                          } */}
                              {checkAccess(12, "view") && (
                                <Link
                                  to={`${app_url}master/deadline-master/payroll-frequency`}
                                  className="dropdown-item"
                                >
                                  {props.t("Payroll Frequency")}
                                </Link>
                              )}
                              {/* {
                            checkAccess(13, 'view') &&
                            <Link to={`${app_url}master/deadline-master/management-account-frequency`} className="dropdown-item">
                              {props.t("Management Account Frequency")}
                            </Link>
                          } */}
                            </div>
                          </div>
                        )
                      }

                      {(checkAccess(14, "view") ||
                        checkAccess(15, "view") ||
                        checkAccess(16, "view") ||
                        checkAccess(17, "view") ||
                        checkAccess(18, "view")) && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/client-info-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Client Info Master")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: ui,
                            })}
                          >
                            {/* {checkAccess(14, "view") && (
                              <Link
                                to={`${app_url}master/client-info-master/client-type`}
                                className="dropdown-item"
                              >
                                {props.t("Client Type")}
                              </Link>
                            )} */}
                            {checkAccess(15, "view") && (
                              <Link
                                to={`${app_url}master/client-info-master/bookkeeper`}
                                className="dropdown-item"
                              >
                                {props.t("Bookkeeper")}
                              </Link>
                            )}
                            {checkAccess(16, "view") && (
                              <Link
                                to={`${app_url}master/client-info-master/bookkeeping-system`}
                                className="dropdown-item"
                              >
                                {props.t("Bookkeeping System")}
                              </Link>
                            )}
                            {checkAccess(17, "view") && (
                              <Link
                                to={`${app_url}master/client-info-master/prefix-master`}
                                className="dropdown-item"
                              >
                                {props.t("Prefix Master")}
                              </Link>
                            )}
                            {checkAccess(18, "view") && (
                              <Link
                                to={`${app_url}master/client-info-master/document-master`}
                                className="dropdown-item"
                              >
                                {props.t("Document Master")}
                              </Link>
                            )}
                          </div>
                        </div>
                      )}

                      {(checkAccess(19, "view") || checkAccess(20, "view")) && (
                        <div className="dropdown">
                          <Link
                            to={`${app_url}master/finance-master`}
                            className="dropdown-item dropdown-toggle arrow-none"
                          >
                            {props.t("Finance Master")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", { show: ui })}
                          >
                            {checkAccess(19, "view") && (
                              <Link
                                to={`${app_url}master/finance-master/invoicing-method`}
                                className="dropdown-item"
                              >
                                {props.t("Invoicing Method")}
                              </Link>
                            )}
                            {checkAccess(20, "view") && (
                              <Link
                                to={`${app_url}master/finance-master/payment-method`}
                                className="dropdown-item"
                              >
                                {props.t("Payment Method")}
                              </Link>
                            )}
                          </div>
                        </div>
                      )}

                      {checkAccess(21, "view") && (
                        <div className="dropdown">
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${app_url}master/reference-master`}
                          >
                            {props.t("Reference Master")}{" "}
                            <div className="arrow-down"></div>
                          </Link>
                          <div
                            className={classname("dropdown-menu", {
                              show: ui,
                            })}
                          >
                            {checkAccess(21, "view") && (
                              <Link
                                to={`${app_url}master/reference-master/connected-master`}
                                className="dropdown-item"
                              >
                                {props.t("Connected Client")}
                              </Link>
                            )}
                            {/* <Link to={`${app_url}master/reference-master/designation-master`} className="dropdown-item">
                          {props.t("Designation Masters")}
                        </Link> */}
                          </div>
                        </div>
                      )}
                    </div>
                  </li>
                )}

                {/* clients management */}
                {checkAccess(1, "view") && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}clients`}
                    >
                      <i className="fas fa-users me-2"></i>
                      {props.t("Clients")} {props.menuOpen}
                    </Link>
                  </li>
                )}

                {/* task management */}
                {checkAccess(2, "view") && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}tasks`}
                    >
                      <i className="fas fa-list-ol me-2"></i>
                      {props.t("Tasks")} {props.menuOpen}
                    </Link>
                  </li>
                )}

                {/* email list */}
                {checkAccess(3, "view") && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}email-templates`}
                    >
                      <i className="fas fa-envelope me-2"></i>
                      {props.t("Email Templates")} {props.menuOpen}
                    </Link>
                  </li>
                )}

                {/* invoices */}
                {checkAccess(23, "view") && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}invoices`}
                    >
                      <i className="fas fa-book me-2"></i>
                      {props.t("Invoices")} {props.menuOpen}
                    </Link>
                  </li>
                )}

                {/* roles */}
                {checkAccess(22, "view") && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}roles-and-permissions`}
                    >
                      <i className="fas fa-user-lock me-2"></i>
                      {props.t("Roles & Permission")} {props.menuOpen}
                    </Link>
                  </li>
                )}

                {/* minutes of meeting */}
                {checkAccess(30, "view") && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${app_url}minutes-of-meeting`}
                    >
                      <i className="fas fa-hourglass me-2"></i>
                      {props.t("MOM")} {props.menuOpen}
                    </Link>
                  </li>
                )}

                {/* reports */}
                {(checkAccess(24, "view") ||
                  checkAccess(26, "view") ||
                  checkAccess(28, "view")) && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      onClick={e => {
                        e.preventDefault()
                      }}
                      to={`${app_url}`}
                    >
                      <i className="fas fa-list me-2"></i>
                      {props.t("Report")} {props.menuOpen}
                      <div className="arrow-down"></div>
                    </Link>
                    <div className={classname("dropdown-menu ", { show: ui })}>
                      <Row>
                        <div>
                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/timesheet`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t(
                                  `${
                                    loggedin_user.id !== 1 ? "My" : ""
                                  } Timesheet`
                                )}
                              </Link>
                            </div>
                          )}

                          {checkAccess(28, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/employee/designation/report`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Employee Designation Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(24, "view") &&
                            loggedin_user.id !== 1 && (
                              <div className="dropdown">
                                <Link
                                  to={`${app_url}report/reportee-timesheet`}
                                  className="dropdown-item dropdown-toggle arrow-none"
                                >
                                  {props.t("Reportees Timesheet")}
                                </Link>
                              </div>
                            )}

                          {/* {checkAccess(24, "view") && (
                              <div className="dropdown">
                                <Link
                                  to={`${app_url}report/employee-report`}
                                  className="dropdown-item dropdown-toggle arrow-none"
                                >
                                  {props.t("Employee Summary Report")}
                                </Link>
                              </div>
                            )} */}

                          {/* {checkAccess(24, "view") && (
                              <div className="dropdown">
                                <Link
                                  to={`${app_url}report/employee/weekly/report`}
                                  className="dropdown-item dropdown-toggle arrow-none"
                                >
                                  {props.t("Employee Weekly Report")}
                                </Link>
                              </div>
                            )} */}

                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/latest/tasks/log`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Latest Task Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/urgent/attention`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Urgent Attention Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/actr/missing/task`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("ACTR Missing Task Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/employee/daily/report`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Employee Daily Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/active/employee/timer`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Active Employee Timer")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(29, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/budget-report`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Budget Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(26, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/gocardless-payments`}
                                className="dropdown-item"
                              >
                                {props.t("Gocardless Report")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(24, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/automated/mails`}
                                className="dropdown-item dropdown-toggle arrow-none"
                              >
                                {props.t("Automated Email Reports")}
                              </Link>
                            </div>
                          )}

                          <div className="dropdown">
                            <Link
                              to={`${app_url}report/invoice-payment-reports`}
                              className="dropdown-item"
                            >
                              {props.t("Invoice & Payment")}
                            </Link>
                          </div>

                          {/* <div className="dropdown">
                              <Link
                                to={`${app_url}report/reports/services-task`}
                                className="dropdown-item"
                              >
                                {props.t("Reports")}
                              </Link>
                            </div> */}
                        </div>
                      </Row>
                    </div>
                  </li>
                )}

                {/* Logs */}
                {(checkAccess(25, "view") || checkAccess(27, "view")) && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      onClick={e => {
                        e.preventDefault()
                      }}
                      to={`${app_url}`}
                    >
                      <i className="fas fa-list me-2"></i>
                      {props.t("Logs")} {props.menuOpen}
                      <div className="arrow-down"></div>
                    </Link>
                    <div className={classname("dropdown-menu ", { show: ui })}>
                      <Row>
                        <div>
                          {checkAccess(27, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/email-logs`}
                                className="dropdown-item"
                              >
                                {props.t("Email Logs")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(25, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/audit-logs`}
                                className="dropdown-item"
                              >
                                {props.t("Audit Logs")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(25, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/company-house-details-update-logs`}
                                className="dropdown-item"
                              >
                                {props.t("Company House Logs")}
                              </Link>
                            </div>
                          )}

                          {checkAccess(25, "view") && (
                            <div className="dropdown">
                              <Link
                                to={`${app_url}report/scheduled-email-logs`}
                                className="dropdown-item"
                              >
                                {props.t("Scheduled Email Logs")}
                              </Link>
                            </div>
                          )}
                        </div>
                      </Row>
                    </div>
                  </li>
                )}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
